// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb__float-menu[data-v-0079755b]{position:fixed;z-index:99}.active div.mb__w-100pc[data-v-0079755b]{opacity:1;color:#fff}", ""]);
// Exports
module.exports = exports;
